/**
 * Comments, Calls, Logs, Statistics, Notifications,
 * Exports, Company Profiles endpoints
 */

export const commentsEndpoints = {
  list: (quoteId) => `/api/comments/quote/${quoteId}`,
  create: () => '/api/comments',
  update: (commentId) => `/api/comments/${commentId}`,
  delete: (commentId) => `/api/comments/${commentId}`
}

export const callsEndpoints = {
  create: () => '/api/calls',
  update: (id) => `/api/calls/${id}`
}

export const logsEndpoints = {
  list: () => '/api/logs',
  stats: () => '/api/logs/stats'
}

export const statisticsEndpoints = {
  dashboard: () => '/api/statistics/dashboard',
  timeline: () => '/api/statistics/timeline',
  firstCallTime: () => '/api/stats/first-call-time',
  monthlyCommercial: (year, month) => `/api/stats/monthly-commercial?year=${year}&month=${month}`,
  // L'historique du chiffre d'affaires, mois par mois. Le serveur le calculait
  // déjà et personne ne l'appelait : il n'existait aucun moyen de comparer deux
  // mois sans changer le sélecteur et retenir le chiffre.
  monthlyCommercialHistory: (months) => `/api/stats/monthly-commercial/history?months=${months}`
}

export const notificationsEndpoints = {
  list: () => '/api/notifications',
  unreadCount: () => '/api/notifications/unread-count',
  markRead: (id) => `/api/notifications/${id}/read`,
  markAllRead: () => '/api/notifications/read-all',
  delete: (id) => `/api/notifications/${id}`
}

export const exportsEndpoints = {
  quotes: {
    csv: () => '/api/exports/quotes/csv',
    excel: () => '/api/exports/quotes/excel'
  },
  contacts: {
    csv: () => '/api/exports/contacts/csv',
    excel: () => '/api/exports/contacts/excel'
  },
  stats: {
    pdf: () => '/api/exports/stats/pdf'
  },
  formationsCatalogue: {
    pdf: () => '/api/exports/formations-catalogue/pdf'
  }
}

export const interSessionsEndpoints = {
  list: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : ''
    return `/api/inter-sessions${qs}`
  },
  detail: (id) => `/api/inter-sessions/${id}`,
}

/** Salles à louer (onglet « Locations de salles » des sessions inter). */
export const sallesLocationEndpoints = {
  list: () => '/api/salles-location',
  detail: (id) => `/api/salles-location/${id}`,
}

function buildQuery(params) {
  if (!params) return ''
  const sp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      sp.append(key, value)
    }
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}

export const advertisementsEndpoints = {
  list: () => '/api/advertisements',
  detail: (id) => `/api/advertisements/${id}`,
  create: () => '/api/advertisements',
  update: (id) => `/api/advertisements/${id}`,
  delete: (id) => `/api/advertisements/${id}`,
  toggleStatut: (id) => `/api/advertisements/${id}/statut`,
  upload: () => '/api/advertisements/upload',
  imageUrl: (id) => `/api/advertisements/${id}/image-url`,
  stats: (params) => `/api/advertisements/stats${buildQuery(params)}`
}


export const companyProfilesEndpoints = {
  list: () => '/api/company-profiles',
  listWithAddresses: () => '/api/company-profiles?includeAddresses=true',
  detail: (id) => `/api/company-profiles/${id}`,
  create: () => '/api/company-profiles',
  update: (id) => `/api/company-profiles/${id}`,
  delete: (id) => `/api/company-profiles/${id}`,
  restore: (id) => `/api/company-profiles/${id}/restore`,
  automaticEmails: (id) => `/api/company-profiles/${id}/automatic-emails`
}
